module.exports = __webpack_public_path__ + "img/dialog-back.5cf78a28.svg";